import React, { useEffect, useState } from 'react';

const GoogleTranslate: React.FC = () => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    // Check if already loaded
    if ((window as any).google?.translate) {
      console.log('Google Translate already available');
      initializeWidget();
      return;
    }

    // Create initialization function
    (window as any).googleTranslateElementInit = function() {
      try {
        initializeWidget();
      } catch (error) {
        console.error('Google Translate initialization error:', error);
      }
    };

    // Load script only once
    if (!document.querySelector('script[src*="translate.google.com"]')) {
      const script = document.createElement('script');
      script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
      script.async = true;
      script.onerror = () => {
        console.error('Failed to load Google Translate script');
      };
      document.body.appendChild(script);
    }
  }, []);

  const initializeWidget = () => {
    const element = document.getElementById('google_translate_element');
    if (!element) {
      console.warn('google_translate_element not found');
      return;
    }

    // Clear existing content
    element.innerHTML = '';

    try {
      new (window as any).google.translate.TranslateElement(
        {
          pageLanguage: 'en',
          includedLanguages: 'en,fa,ar,fr,es,zh-CN,hi,pa,tl,vi,ko,uk,ru',
          layout: (window as any).google.translate.TranslateElement.InlineLayout.SIMPLE,
          autoDisplay: false
        },
        'google_translate_element'
      );
      console.log('✅ Google Translate widget initialized');
      setLoaded(true);
    } catch (error) {
      console.error('Widget initialization error:', error);
    }
  };

  return (
    <div 
      id="google_translate_element"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        minWidth: loaded ? 'auto' : '100px',
        minHeight: '30px',
      }}
    />
  );
};

export default GoogleTranslate;
